interface PageMainTitle {
  category: string
  title: string
  sub_title: string
  sub_title2: string
  text: string
}

export const pageMainTitle: PageMainTitle = {
  category: '事例',
  title: 'Case study',
  sub_title: '',
  sub_title2: '',
  text: 'i3DESGINのプロジェクト事例をまとめました。総合デジタルプロデュース企業として、コンサルティング、UI/UXデザイン、アプリやウェブのサービス開発、AIやxRの導入など、幅広くご支援しております。',
}
